<template>
  <div class="action_column" :class="{ border_right: !isLastColumn }" :style="{ minWidth: columnWidth }">
    <div class="action_content">
      <template v-if="showCustomActionComponent">
        <component class="mr-6" :is="customActionComponent" :row="row" :custom-action-key="customActionKey" />
      </template>

      <div v-if="quickActions?.length > 0" class="quick_actions_wrapper">
        <template v-for="(action, actionIndex) in quickActions" :key="actionIndex">
          <DownloadIcon v-if="action.id === quickActionsTypes.DOWNLOAD" :row="row" :action="action" @action="action.handler(row)" />
          <ViewIcon v-else-if="action.id === quickActionsTypes.VIEW" :row="row" :action="action" @action="action.handler(row)" />
        </template>
      </div>

      <CustomDropdown v-if="actions?.length > 0" gap="4px" position="end" :relative-to-viewport="true" :disabled="row[isMoreOptionsDisabled]">
        <template #trigger>
          <div class="quick_action_item mt-1">
            <img :src="imagePath.moreIconVertical" alt="more_icon" class="size-5 cursor-pointer opacity-60" />
          </div>
        </template>

        <template #default>
          <div v-for="(action, actionIndex) in actions" :key="actionIndex" @click="handleAction(action, row)" class="dropdown_item text-sm">
            <img v-if="action.label === 'Add Action'" class="size-3 opacity-50" :src="action.icon" alt="action_option" />
            <img v-else class="size-3" :src="action.icon" alt="action_option" />
            {{ action.label }}
          </div>
        </template>
      </CustomDropdown>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import CustomDropdown from '@/components/custom/CustomDropdown.vue';
import imagePath from '@/javascript/imagePath';
import DownloadIcon from '@/components/custom/DownloadIcon.vue';
import { quickActionsTypes } from '@/constants/componentConstants.js';
import ViewIcon from '@/components/custom/ViewIcon.vue';

const props = defineProps({
  row: { type: Object, required: true },
  rowIndex: { type: Number, required: true },
  actions: { type: Array, default: () => [] },
  source: { type: String, required: true },
  entityLists: { type: Array, default: () => [] },
  sequences: { type: Array, default: () => [] },
  isSequenceEnabled: { type: Boolean, default: false },
  columnWidth: { type: String, required: true },
  isLastColumn: { type: Boolean, default: false },
  quickActions: { type: Array, default: () => [] },
  fromProspect: { type: Boolean, required: false, default: false },
  dropdownIndex: { type: Number, default: null },
  dropdownPosition: { type: Object, default: () => ({ top: 0, left: 0 }) },
  customActionKey: { type: String, required: false },
  customActionComponent: { type: Object, default: null },
  isMoreOptionsDisabled: { type: String, required: false },
  prospectData: { type: Boolean, default: false, required: false },
});

const emit = defineEmits(['action']);

const showCustomActionComponent = computed(() => {
  return props.customActionComponent && props.customActionKey;
});

const handleAction = (action, row) => {
  const excludedActions = ['call', 'add_to_list', 'add_to_sequence'];
  if (!excludedActions.includes(action.id)) {
    emit('action', { action, row });
  }
};
</script>

<style scoped>
.action_column {
  background-color: transparent;
  display: flex;
  flex-direction: column;
}

.action_content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid var(--white-opacity-12);
  box-sizing: border-box;
}

.quick_actions_wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  flex-shrink: 0;
}

.border_right {
  border-right: 1px solid var(--white-opacity-12);
}

.dropdown_item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.dropdown_item:hover {
  background-color: var(--white-opacity-4);
}
</style>
